import React from "react";
import { withTranslation } from "react-i18next";
import Text from "components/Text";
import { handleError, handleSuccess } from "utils";
import { acceptAiPolicyAgreement } from "repositories/ai-assistant-repository";
import { getProfile } from "actions";
import { useDispatch } from "react-redux";

function ChatAgreement({ t }) {
  const dispatch = useDispatch();
  const [before, after] = t("aiAssistant.agreementText").split(
    "{{policyLink}}"
  );

  const acceptAgreement = async () => {
    try {
      const res = await acceptAiPolicyAgreement();
      handleSuccess(res?.message);
      dispatch(getProfile());
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className="assistant-card">
      <Text color="#2D3245" size="14px" weight="400">
        {before}
        <a href="/privacy-policy" target="blank" style={{ display: "inline" }}>
          <Text as="span" color="#587E85" size="14px" weight="400" underline>
            {t("privacyPolicy")}
          </Text>
        </a>
        {after}
      </Text>
      <div className="btn-box d-md-flex gap-sm padding_top_10">
        <button
          className="button button-round button-shadow w-sm-100  mr-md-2"
          title={t("aiAssistant.agreeBtn")}
          onClick={() => {
            acceptAgreement();
          }}
        >
          {t("aiAssistant.agreeBtn")}
        </button>
      </div>
    </div>
  );
}

export default withTranslation()(ChatAgreement);
